/**
 * VIRUS Scroll Animations - Horizon Theme
 * Version: 3.6.5 - With collection-links image
 */

(function() {
  'use strict';

  const CONFIG = {
    threshold: 0.1,
    rootMargin: '0px 0px -30px 0px'
  };

  // Elements to animate on scroll
  const SELECTORS = [
    '.hero__content-wrapper > .group-block',
    '.hero__content-wrapper > .text-block',
    '.section-content-wrapper > .group-block',
    '.section-content-wrapper > .text-block',
    '.section-content-wrapper > .image-block',
    '.collection-links__link',
    '.collection-links__images'  // <-- Added for the collection image slideshow
  ];

  const COLLECTION_SELECTORS = ['.product-grid__card'];

  const EXCLUDE_ANCESTORS = [
    '.resource-list',
    '.resource-list__carousel',
    '.okeReviews',
    '.hooper',
    'quick-add-modal'
    // Removed 'slideshow-component' - collection-links uses it safely
  ];

  function isExcluded(el) {
    return EXCLUDE_ANCESTORS.some(sel => el.closest(sel));
  }

  // =========================================================================
  // DYNAMIC WIDGET ANIMATION (Okendo Loyalty, etc.)
  // =========================================================================
  
  function animateLoyaltyWidget() {
    const widget = document.querySelector('.okeLoyalty--bannerWidget, .c-bannerWidget, [data-oke-loyalty-banner-widget]');
    if (widget && !widget.classList.contains('loyalty-animated')) {
      widget.classList.add('loyalty-animated');
      widget.style.opacity = '0';
      widget.style.transform = 'translateY(-8px)';
      widget.style.transition = 'opacity 0.4s ease-out, transform 0.4s ease-out';
      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          widget.style.opacity = '1';
          widget.style.transform = 'translateY(0)';
        });
      });
    }
  }

  function watchForWidgets() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          animateLoyaltyWidget();
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    animateLoyaltyWidget();
  }

  // =========================================================================
  // SCROLL ANIMATIONS
  // =========================================================================

  function initScrollAnimations() {
    const template = document.querySelector('main')?.dataset?.template || '';
    const isCollection = template.includes('collection');
    
    let selectors = [...SELECTORS];
    if (isCollection) {
      selectors = selectors.concat(COLLECTION_SELECTORS);
    }

    const elements = [];
    
    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (el.classList.contains('scroll-animate') || el.classList.contains('is-revealed') || isExcluded(el)) {
          return;
        }
        elements.push(el);
      });
    });

    console.log('[VIRUS Scroll] Found', elements.length, 'elements to animate');

    if (elements.length === 0) return;

    elements.forEach(el => el.classList.add('scroll-animate'));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('is-revealed')) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, CONFIG);

    requestAnimationFrame(() => {
      elements.forEach(el => observer.observe(el));

      elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
          el.classList.add('is-revealed');
        }
      });
    });
  }

  // =========================================================================
  // INIT
  // =========================================================================

  function init() {
    initScrollAnimations();
    watchForWidgets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();